export default "__VITE_ASSET__2fbc8e47__"